<div style="height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;" >
    <div style="text-align: center;"> 
        <img src="/assets/images/shared/check-icon.png" alt="" style="height: 120px; width: 120px; margin-bottom: 10px;"> <br>
        <p style="font-weight: bold;">Поканата ви беше изпратена успешно!</p>
        <p style="color: #ADAFBB;">Веднъж щом трима от поканените се регистрират, ще получите ваучер на стойност 5 лв.</p>
    </div>
</div>
<div style="position: fixed; bottom: 5px; text-align: center; width: 90%; margin: auto; left: 5%;">
    <button type="button" class="btn btn-primary" style="width: 100%; margin: auto;" (click)="this.close()"> Затвори </button>
</div>